class ItemELe extends HTMLElement {
    constructor() {
        super();
        var list_items = document.querySelectorAll('.item');
        for (var i = 0; i < list_items.length; i++) {
            list_items[i].addEventListener("click", toggle);
        }
        function toggle() {
            this.classList.toggle("active");
        }
    }
}
customElements.define('list-item', ItemELe);